const headers = () => {
  return {
    Authorization: `Bearer ${sessionStorage.getItem('authenticated')}`,
    'x-device-token': window.device_token,
  };
};

export const addAddress = async (payload) => await fetchData(`/patients/address`, 'POST', headers(), payload);

export const editAddress = async (payload, id) => await fetchData(`/patients/address/` + id, 'PUT', headers(), payload);

export const deleteAddress = async (id) => await fetchData(`/patients/address/` + id, 'DELETE', headers());

export const getAddress = async () => await fetchData(`/patients/address`, 'GET', headers());

export const putPatientConsent = async (reqBody) => await fetchData(`/coopuser/consent`, 'PUT', headers(), reqBody);

export const getPatientInfo = async () => await fetchData(`/coopuser/info`, 'GET', headers());

const fetchData = async (url, method, headers = null, data = null) => {
  try {
    const response = await fetch(`${window.API_URL}${url}`, {
      method,
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'client-type': 'web',
        ...headers,
      },
      redirect: 'follow',
      referrer: 'no-referrer',
      body: data === null ? null : JSON.stringify(data),
    });

    if (!response.ok) {
      if (response.status === 401) window.location.href = '/pharmacy/logout';
      throw new Error(JSON.stringify(response));
    } else {
      if (response.status === 401) window.location.href = '/pharmacy/logout';
    }

    let body = null;
    try {
      body = await response.json();
    } catch {
      // This will occur if the body is empty
    }

    return body;
  } catch (error) {
    window.location.href = '/pharmacy/logout';
    throw error;
  }
};
